import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=7b67c6de"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports